import { useAppClippo } from '@/core';
import { useField } from 'formik';
import { useEffect } from 'react';
import { Attach } from '../Attach';
import { useClippoBlobs } from '@/utils';

export interface FormsDeferAttachProps {
  name: string;
  noPreload?: boolean;
  ownerType?: string;
  ownerId?: string;
  showActions?: boolean;
  openOnClick?: boolean;
  className?: string;
}

export function FormsDeferAttach(props: FormsDeferAttachProps) {
  const { name, noPreload = true, ownerType, ownerId, ...rest } = props;
  const [, , { setValue, setTouched }] = useField(name);

  const clippo = useAppClippo({
    defer: true,
    noPreload: noPreload,
    ownerType: ownerType,
    ownerId: ownerId,
  });

  const {
    value: { actions },
  } = clippo;

  useEffect(() => {
    setTouched(true);
    setValue(actions, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actions]);

  const clippoBlobs = useClippoBlobs(clippo);

  return <Attach {...clippo} {...rest} blobs={clippoBlobs.blobs} />;
}
